import { AppRestClient } from "@/util/rest/clients/app-rest-client";

import { BizShortlistModels } from "./bizShortlist.models";

export namespace BizShortlistApi {
  export const getShortlist = () => {
    return AppRestClient.get({ resSchema: BizShortlistModels.BizShortlistResponseDtoSchema }, `/biz/shortlist`);
  };

  export const addPosition = (data: BizShortlistModels.AddPositionToShortlistDto) => {
    return AppRestClient.post(
      { resSchema: BizShortlistModels.BizShortlistResponseDtoSchema },
      `/biz/shortlist/positions`,
      data,
    );
  };

  export const removePosition = (positionCode: string) => {
    return AppRestClient.delete(
      { resSchema: BizShortlistModels.BizShortlistResponseDtoSchema },
      `/biz/shortlist/positions/${positionCode}`,
    );
  };
}
